// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyARkBGh6N4VGQO1Bp57FezGj_pHgFggqh8",
  authDomain: "mindfulmusing-aa4af.firebaseapp.com",
  projectId: "mindfulmusing-aa4af",
  storageBucket: "mindfulmusing-aa4af.firebasestorage.app",
  messagingSenderId: "908693789343",
  appId: "1:908693789343:web:32a0eedc983428426620aa",
  measurementId: "G-LMFKETSJY6"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);